import { Controller } from '@hotwired/stimulus';

// Drives the relationship tree on the report builder. Each node's relationships are loaded lazily the
// first time it is expanded: the child turbo-frame carries its endpoint in data-src (so it does not
// auto-load) and we promote that to src on first expand. Later toggles just show/hide the branch.
export default class extends Controller {
  toggle(event) {
    const node = event.currentTarget.closest('.report-tree-node');
    if (!node) return;

    const children = node.querySelector(':scope > .report-tree-children');
    if (!children) return;

    const expanded = children.classList.toggle('d-none') === false;

    const icon = event.currentTarget.querySelector('.tree-toggle-icon');
    if (icon) {
      icon.classList.toggle('fa-chevron-down', expanded);
      icon.classList.toggle('fa-chevron-right', !expanded);
    }
    event.currentTarget.setAttribute('aria-expanded', expanded.toString());

    if (expanded && children.dataset.loaded !== 'true') {
      children.dataset.loaded = 'true';
      const frame = children.querySelector('turbo-frame');
      if (frame && frame.getAttribute('src') == null && frame.dataset.src) {
        frame.setAttribute('src', frame.dataset.src);
      }
    }
  }
}
